import om from "@/api";
import router from "@/router";
import * as END_POINTS from "@/config/constants/end-points";
import * as ACTIONS from "@/config/constants/action-types-bdc";
import * as MUTATIONS from "@/config/constants/mutations-types-bdc";
import * as MUTATIONS_OM from "@/config/constants/mutation-types";
import { createAgroError } from "@/errors/bdc-error-constants";

export default {
  async [ACTIONS.DO_CALL_FILTERS](context) {
    try {
      context.commit(MUTATIONS_OM.ON_IS_LOADING, true);
      const response = await om.get(END_POINTS.AGRO_CONVENIOS_FILTROS);
      context.commit(MUTATIONS_OM.ON_IS_LOADING, false);
      const data = response.data;
      if (data.status === "OK") {
        const filtros = data.respuesta;
        if (Array.isArray(filtros.merchants)) {
          filtros.merchants = filtros.merchants.slice().sort((a, b) => {
            const nameA = (a.nombre || "").toLowerCase();
            const nameB = (b.nombre || "").toLowerCase();
            return nameA.localeCompare(nameB);
          });
        }
        context.commit(MUTATIONS.ON_BDC_SET_FILTERS_DATA, filtros);
        return response;
      } else {
        context.commit(MUTATIONS_OM.ON_IS_LOADING, false);
        const errorData = createAgroError("GENERIC_ERROR_WITH_RETRY", {
          action: ACTIONS.DO_CALL_FILTERS
        });
        context.dispatch(ACTIONS.DO_AGRO_ERROR, errorData);
        return null;
      }
    } catch (e) {
      context.commit(MUTATIONS_OM.ON_IS_LOADING, false);
      const errorData = createAgroError("GENERIC_ERROR_WITH_RETRY", {
        action: ACTIONS.DO_CALL_FILTERS
      });
      context.dispatch(ACTIONS.DO_AGRO_ERROR, errorData);
      return null;
    }
  },

  [ACTIONS.DO_CALL_CONVENIOS]: async (context, payload = {}) => {
    const getParams = p =>
      p && typeof p === "object" && p.params ? p.params : {};
    const getLabelCategoria = p =>
      p && typeof p === "object" ? p.labelCategoria : undefined;
    const setLoading = isLoading =>
      context.commit(MUTATIONS_OM.ON_IS_LOADING, isLoading);
    const handleError = () => {
      const errorData = createAgroError("GENERIC_ERROR_WITH_RETRY", {
        action: ACTIONS.DO_CALL_CONVENIOS
      });
      context.dispatch(ACTIONS.DO_AGRO_ERROR, errorData);
      return null;
    };
    const overwriteCategoria = (convenios, labelCategoria) =>
      (convenios.data = convenios.data.map(convenio => ({
        ...convenio,
        categoriaEmpresa: labelCategoria
      })));

    const overwriteTna = convenios => {
      convenios.data = convenios.data.map(convenio => {
        if (convenio.tna !== undefined && !isNaN(convenio.tna)) {
          return {
            ...convenio,
            tna: String(Math.trunc(Number(convenio.tna)))
          };
        }
        return convenio;
      });
    };

    try {
      const params = getParams(payload);
      const labelCategoria = getLabelCategoria(payload);
      setLoading(true);
      const response = await om.get(END_POINTS.AGRO_CONVENIOS_LISTADO, params);
      setLoading(false);
      const data = response.data;
      if (data.status !== "OK") return handleError();
      let convenios = data.respuesta;
      if (
        !convenios.data ||
        (Array.isArray(convenios.data) && convenios.data.length === 0)
      ) {
        setLoading(false);
        return null;
      }
      if (labelCategoria !== undefined)
        overwriteCategoria(convenios, labelCategoria);
      overwriteTna(convenios);
      context.commit(MUTATIONS.ON_BDC_SET_CONVENIOS_DATA, convenios);
      return convenios;
    } catch (e) {
      setLoading(false);
      return handleError();
    }
  },
  async [ACTIONS.DO_CALL_TIPO_PRODUCTO_FILTER](context) {
    try {
      context.commit(MUTATIONS_OM.ON_IS_LOADING, true);
      const response = await om.get(
        END_POINTS.AGRO_CONVENIOS_FILTRO_TIPO_PRODUCTO
      );
      context.commit(MUTATIONS_OM.ON_IS_LOADING, false);
      const data = response.data;
      if (data.status === "OK") {
        const filtros = data.respuesta.tipoProductos;
        return filtros;
      }
    } catch (e) {
      //ver errores...
      context.commit(MUTATIONS_OM.ON_IS_LOADING, false);
    }
  },

  async [ACTIONS.DO_CALL_CONVENIOS_BY_MERCHANT](
    context,
    { idEmpresa, params = {} }
  ) {
    try {
      context.commit(MUTATIONS_OM.ON_IS_LOADING, true);
      const endpoint = END_POINTS.AGRO_CONVENIOS_BY_MERCHANT_ID.replace(
        "{id}",
        idEmpresa
      );
      const response = await om.get(endpoint, params);
      context.commit(MUTATIONS_OM.ON_IS_LOADING, false);
      const data = response.data;
      if (data.status === "OK") {
        return {
          data: data.respuesta.data || [],
          paginas: data.respuesta.paginas || 0,
          registros: data.respuesta.registros || 0,
          hasError: false
        };
      } else {
        return { data: [], paginas: 0, registros: 0, hasError: true };
      }
    } catch (e) {
      context.commit(MUTATIONS_OM.ON_IS_LOADING, false);
      return { data: [], paginas: 0, registros: 0, hasError: true };
    }
  },

  /**
   * Navegar a la pantalla de error de Agro guardando datos en Vuex
   * @param {Object} context Vue Context
   * @param {Object} errorData Datos del error (desde error-constants)
   */
  [ACTIONS.DO_AGRO_ERROR]: (context, errorData) => {
    context.commit(MUTATIONS.SET_AGRO_ERROR, errorData);
    router.push({ name: "agroErrorBdc" });
  },

  [ACTIONS.DO_ROUTE_PUSH_HOME]() {
    router.push("/buscador-convenios");
  },

  async [ACTIONS.DO_SEND_NOTIFICATION_EMAIL](context, payload) {
    let response = { hasError: false };
    try {
      context.commit(MUTATIONS_OM.ON_IS_LOADING, true);
      const apiResponse = await om.request({
        endPoint: END_POINTS.AGRO_CONVENIOS_SEND_NOTIFICATION_EMAIL,
        body: payload
      });
      context.commit(MUTATIONS_OM.ON_IS_LOADING, false);
      const data = apiResponse.data;
      if (data.status !== "OK") {
        response.hasError = true;
      }
      return response;
    } catch (e) {
      response.hasError = true;
      context.commit(MUTATIONS_OM.ON_IS_LOADING, false);
      return response;
    }
  }
};
